import dayjs from 'dayjs';

export default {
  data() {
    return {
      setTime: null,
      timestamp: dayjs().valueOf(),
      playbackRate: 1,
      playing: false,
      live: true,
    };
  },
  methods: {
    getTime(val) {
      this.setTime = val;
    },
  },
};
